import { createReducer } from '@reduxjs/toolkit';
import { GroupSetsStoreState } from '@Types/groupSets.types';
import {
	getGroupSetAction,
	getGroupSetResolved,
	listGroupSets,
	listGroupSetsResolved,
} from '@Actions/groupSets.actions';

export const initState: GroupSetsStoreState = {
	isLoading: false,
	groupSetsList: [],
	groupSet: {
		isLoading: false,
		groupSet: null,
	},
};

export const groupSetsReducer = createReducer(initState, builder => {
	builder
		.addCase(listGroupSets, state => {
			state.isLoading = true;
		})
		.addCase(listGroupSetsResolved, (state, action) => {
			state.groupSetsList = action.payload;
			state.isLoading = false;
		})
		.addCase(getGroupSetAction, state => {
			state.groupSet = {
				isLoading: true,
				groupSet: null,
			};
		})
		.addCase(getGroupSetResolved, (state, action) => {
			state.groupSet = {
				isLoading: false,
				groupSet: {
					id: action.payload._id,
					name: action.payload.name,
					publishState: action.payload.publishState,
					systemType: action.payload.systemType,
					assetType: action.payload.assetType,
				},
			};
		});
});

export default groupSetsReducer;
